import React from 'react';
import Cellphone from './images/phone.png';

const Phone = () => {
    return (
        <>
          <img className="img-fluid" src={Cellphone} alt="phone" style={{maxWidth: "100%"}} />  
        </>
    )
}

export default Phone
